import React from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from '@material-ui/core/CircularProgress';
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import Danger from "components/Typography/Danger";
import { post_report_image } from "utils/http";


import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class ReportImageUploadDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            files: [],
            errorMessage: "",
            filesIsUploading: false,
        };
    }

    onDrop(newFiles) {
        if (!this.props.maxFiles || newFiles.length + this.state.files.length <= this.props.maxFiles) {
            this.setState(prevState => ({
                files: [
                    ...prevState.files,
                    ...newFiles,
                ]
            }))
        } else {
            this.setState({
                errorMessage: "Достигнуто максимальное колтчество файлов."
            })
        }
    }

    componentWillUnmount(){
        this.setState({
            files: [],
            errorMessage: "",
            filesIsUploading: false,
        })
    }

    async postImages(){
        let promises = Array(this.state.files.length);
        this.state.files.forEach((file, id) => {
            promises[id] = post_report_image(this.props.token, this.props.report_id, file)
        });
        this.setState({
            filesIsUploading: true
        });
        // eslint-disable-next-line
        const results = await Promise.all(promises);
        this.setState({
            filesIsUploading: false,
        });
        this.props.onCancel();
        this.setState({
            files: [],
            errorMessage: "",
            filesIsUploading: false,
        });
    }

    render(){
        const { classes, onCancel, isOpened } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Загрузить фотографию</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    {this.state.errorMessage && <Danger>{this.state.errorMessage}</Danger>}
                    <Dropzone className={classes.dropzone}
                              onDrop={this.onDrop.bind(this)}>
                        <div className={classes.flexContainer}>
                            <span className={classes.flexItem}>Перетащите фотографии в эту область или кликните для выбора файлов</span>
                        </div>
                    </Dropzone>
                    {
                        this.state.files.map((f, id) => <li key={id} className={classes.flex_sp_btw}><span style={{margin: "auto 0"}}>{f.name} - {f.size} bytes</span>
                            <IconButton
                                key="del"
                                aria-label="Del"
                                color="inherit"
                                onClick={() => this.setState(prevState => ({
                                    files: prevState.files.filter((f, f_id) => f_id !== id ? f : null).filter(n => n),
                                    errorMessage: "",
                                }))}
                            >
                                <Close/>
                            </IconButton></li>)
                    }
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    { this.state.filesIsUploading && <CircularProgress className={classes.progress} size={50}/> }
                    <Button color="primary"
                            onClick={() => this.postImages()}
                    >
                        Загрузить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

ReportImageUploadDialog.propTypes = {
    maxFiles: PropTypes.number,
    token: PropTypes.string,
    report_id: PropTypes.number,
    onCancel: PropTypes.func,
};

ReportImageUploadDialog.defaultProps = {
};

export default withStyles(modalStyle)(ReportImageUploadDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/ReportImageUploadDialog.jsx